/**
 * 类目选择器
 * Author: FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/02/14      1.0     First version 多选 Multi
 *
 * @param canSelectNum 配置canSelectNum达到数量后禁用checkbox，0不限制
 * @return [{
                value: value,
                label: "label"
            }]
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from 'react';
import {TreeSelect} from "antd";
import "./index.less";
import PropTypes from "prop-types";
import CategorySelectorService from "./CategorySelector.action";
class CategorySelector extends React.Component {
    static propTypes = {
        canSelectNum: PropTypes.number,
        initialValue: PropTypes.array,
        getCateUrl: PropTypes.string
    }
    static defaultProps = {
        canSelectNum: 0,
        initialValue:[],
        size: 'large',
    };
    constructor(props) {
        super(props);
        console.log(props.initialValue)
        this.state = {
            getCateUrl:props.getCateUrl || '/bportal/portal/r/brand/threeCategory',
            treeData: [],
            checkedKeys: props.initialValue || [],
            // checkedKeys: [2254],
            
            disableCheckbox:false
        }
    }
    /**
     * 请求
     * */
    postHttpAction (sUrl, data, callback) {
        return $.ajax({
            url: sUrl,
            type: 'post',
            dataType: "json",
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: (res) => {
               callback(res)
            }
        });
    }
    onLoadData = treeNode =>
        new Promise(resolve => {
            const { id } = treeNode.props;
            const { treeData,getCateUrl, } = this.state;
            this.postHttpAction(getCateUrl,{id:id},resp=>{
                // 响应结果
                if(resp.valid&&resp.success){
                    const models = resp.models||[];
                    if(models.length>0){
                        const categoryList = models[0].categoryList||[];
                        let list = [];
                        categoryList.forEach(item=>{
                            list.push({
                                id: item.id,
                                pId: id,
                                checkable:true,
                                value: item.id,
                                title: item.name,
                                isLeaf: true
                            })
                        })
                        this.setState({
                            treeData: treeData.concat(list),
                        });
                        resolve();
                    }
                }
            })
        })

    genTreeData = (data={}) => {
        CategorySelectorService.fetch(this.state.getCateUrl,data).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
    };
    /**
     * 获取初始
     * */
    handleRes(resp){
        // 响应结果
        if(resp.valid&&resp.success){
            const treeData = resp.models||[];
            if(treeData.length>0){
                let list = [];
                treeData.forEach(item=>{
                    list.push({
                        id: item.id,
                        value: item.id,
                        key:item.id,
                        title: item.name,
                        checkable:false,
                    })
                })
                this.setState({
                    treeData:list
                })
            }
        }
    }
    onChange = (value, label, extra) => {
        // this.setState({
        //     checkedKeys:value
        // })
        // alert(value)
        const { treeData,disableCheckbox,checkedKeys } = this.state;
        let newChecks = [...checkedKeys]
        if(extra.checked){//选择时触发
            const curr = treeData.find(item=>item.id==extra.triggerValue)||{};
            const pId = curr.pId;
            if(pId){
                const parentJson = treeData.find(item=>item.id==pId);
                newChecks.push({
                    label :  parentJson.title + "->" + extra.triggerNode.props.title,
                    value : extra.triggerValue,
                })
            }
        }else {
            // console.log(newChecks)
            newChecks = value.map(item => item.value)
            // newChecks = newChecks.filter(item=>item.value!=extra.triggerValue);
        }
        if(this.props.onChange)this.props.onChange(value);
        const { canSelectNum } = this.props;
        const newDisableCheckbox = canSelectNum&&value.length>=canSelectNum?true:false;
        if(disableCheckbox!=newDisableCheckbox){
            let newTreeData = [...treeData];
            newTreeData.forEach(item=>{
                item.disableCheckbox = newDisableCheckbox;
            })
            this.setState({
                treeData:newTreeData,
                checkedKeys:newChecks,
                disableCheckbox:newDisableCheckbox
            });
        }else {
            this.setState({ checkedKeys:newChecks });
        }
    };
    componentDidMount(){
     this.genTreeData()
    }
    render(){
        const { disabled,placeholder,size} = this.props;
        const {treeData, checkedKeys, } = this.state;
        return (<div className={"categoryTreeSelect"}> <TreeSelect 
            disabled={disabled} 
            // size={size}
            treeDataSimpleMode
            labelInValue={true}
        //  treeCheckable={true}
            multiple
            style={{ width: '100%' }}
            value={checkedKeys}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            placeholder={placeholder}
            onChange={this.onChange}
            loadData={this.onLoadData.bind(this)}
            treeData={treeData}  />
        </div>)}
}
export default CategorySelector;
